import { useAuthenticatedMutation } from "@l2r-front/l2r-auth"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"

export function useRoadsideInventoriesMutation(
    url,
    axiosFn,
    queryParameters,
    config: any = {},
) {
    const { selectedNetwork } = useNetworksStateContext()
    const apiUrl = `roadside_inventory/roadside_inventories/${url}`

    return useAuthenticatedMutation(
        apiUrl,
        axiosFn,
        { ...queryParameters, project: selectedNetwork?.slug },
        {
            ...config,
            enabled: config.enabled && !!selectedNetwork
        },
    )
}